import * as React from 'react';
import { Navigation } from './navigation/navigation';
import { LanguageSwitcher } from './language-switcher/language-switcher';
import './header.scss';

export const Header: React.FC = () => (
  <header className="header">
    <div className="container--fluid">
      <div className="header-inner">
        <Navigation />
        <LanguageSwitcher />
      </div>
    </div>
  </header>
);
